import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import DashboardPage from "./pages/DashboardPage";
import ForgeStudioPage from "./pages/ForgeStudioPage";
import InvoiceViewPage from "./pages/InvoiceViewPage";
import InvoiceFormPage from "./pages/InvoiceFormPage";
import VerifyPage from "./pages/VerifyPage";
import SettingsPage from "./pages/SettingsPage";
import DocumentStudioPage from "./pages/DocumentStudioPage";
import DocumentsListPage from "./pages/DocumentsListPage";
import DocumentViewPage from "./pages/DocumentViewPage";
import VerifyDocumentPage from "./pages/VerifyDocumentPage";
import NotFoundPage from "./pages/NotFoundPage";
import { Toaster } from "./components/ui/sonner";
import { CenturionProvider } from "./context/CenturionContext";
import { CompanyProvider } from "./context/CompanyContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <CenturionProvider>
        <CompanyProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/studio/invoice" element={<ForgeStudioPage />} />
              <Route path="/forge" element={<ForgeStudioPage />} />
              <Route path="/invoices/new" element={<InvoiceFormPage mode="create" />} />
              <Route path="/invoices/:id" element={<InvoiceViewPage />} />
              <Route path="/invoices/:id/edit" element={<InvoiceFormPage mode="edit" />} />
              <Route path="/verify/:vid" element={<VerifyPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/studio/documents" element={<DocumentStudioPage />} />
              <Route path="/documents" element={<DocumentsListPage />} />
              <Route path="/documents/:id" element={<DocumentViewPage />} />
              <Route path="/verify-doc/:vid" element={<VerifyDocumentPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <Toaster position="bottom-right" theme="dark" richColors />
          </BrowserRouter>
        </CompanyProvider>
      </CenturionProvider>
    </div>
  );
}

export default App;
